'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Inserter = require('./Inserter');
var findFunctions = require('./findFunctions');

/**
 * Put inspect
 * @param {string} source
 * @param {string} fileId
 * @param {boolean} [skipInit=false]
 * @returns {Object}
 */
function putInspect(source, fileId) {
  var skipInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var functions = findFunctions(source);

  if (!functions.length) return { functions: functions };

  var inserter = new Inserter(source);

  if (!skipInit) {
    inserter.insert('const {Inspector} = require(\'auto-docu\')\n', 0);
    inserter.insert('var inspector = new Inspector(' + ('\'' + fileId + '\'') + ')\n\n', 0);
  }

  functions.forEach(function (func, i) {
    var cb = '() => { ' + inserter.original.slice(func.body.start, func.body.end) + ' }';
    if (func.async) cb = 'async ' + cb;
    var inspect = void 0;
    if (func.hasBody) {
      inspect = 'return inspector.inspect(' + [i, cb].concat(_toConsumableArray(func.params.map(function (p) {
        return p.accessor;
      }))).join(', ') + ')';
    } else {
      inspect = 'inspector.inspectInline(' + [i].concat(_toConsumableArray(func.params.map(function (p) {
        return p.accessor;
      }))).join(', ') + ').returns = ';
    }

    inserter.insert(inspect, func.body.start, func.body.end);
  });

  return {
    source: inserter.source,
    functions: functions
  };
}

module.exports = putInspect;


//////////////////
// WEBPACK FOOTER
// ../lib/putInspect.js
// module id = 494
// module chunks = 0